import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (!owner || owner === "undefined") return Promise.resolve({ data: [] });
  return http.get(`/ileyasavings/${owner}` , { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/ileyasavings/${id}` , { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/ileyasavings/${owner}`, data , { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/ileyasavings/${id}`, data , { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/ileyasavings/${id}` , { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/ileyasavings` , { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/ileyasavings?title=${title}` , { headers: authHeader() });
};

const IleyaSavingsService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default IleyaSavingsService;
